import { PriceNumeric_Schema } from "@/services/prices/priceSchema";
import { z } from "zod";

export const Voucher_Schema = z
  .object({
    code: z.string(),
    value: PriceNumeric_Schema,
    // There's more, we do not use them. See doc for other props.
  })
  .meta({
    openapi: "VoucherCodeReadResponse",
  });
